import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from '../services/setupInterceptors';

const initialState = {homeHeader:[],newProducts:[]};

export const retrieveHeaderBanners= createAsyncThunk(
    "bannerItem/retrieveHeader",
    async (_,thunkAPI)=>{
        const {data} = await axiosClient.get("banners/active?placement=Homepage+Hero");
        return data?.success?data: thunkAPI.rejectWithValue("Error");
    },{
        condition:(_,{getState})=>{
            return  (getState().banners.homeHeader.length===0)   
        }
    }
)


const bannerSlice = createSlice({
    name:"banners",
    initialState,
    extraReducers: (builder) => {
        builder
        .addCase(retrieveHeaderBanners.pending, (state) => {
            state.status = 'loading';
            state.error = null;
        })
        .addCase(retrieveHeaderBanners.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.homeHeader = action.payload.data;
        })
        .addCase(retrieveHeaderBanners.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        })
    }
})

export default bannerSlice.reducer;